<template>
	<div>
		<action-sidebar :title="title" :value="true" @close-modal="closeModal">
			<v-layout wrap pa-5>
				<v-flex xs12 pb-3>
					<v-text-field 
						background-color="white" 
						box 
						class="body-1" 
						hide-details 
						label="Título de la Promoción"
						v-model="$v.model.title.$model" 
						:error="$v.model.title.$error">
					</v-text-field>
				</v-flex>
				
				<v-flex xs12 pb-3>
					<v-textarea 
						background-color="white" 
						box 
						class="body-1 mt-2" 
						hide-details 
						label="Descripción"
						v-model="model.description">
					</v-textarea>
				</v-flex>
				
				<v-flex xs12 pb-3 class="mt-3">
					<v-switch
						color="green"
						label="Promoción Activa"
						v-model="model.isActive"
						hide-details
					></v-switch>
				</v-flex>
			</v-layout>
			
			<section class="modal-filter-footer">
				<modal-sidebar-button 
					:is-loading="$v.$invalid || loading" 
					@accept-button-clicked="saveService"
					@cancel-button-clicked="closeModal">
				</modal-sidebar-button>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import { required } from 'vuelidate/lib/validators';

function closeModal() {
	this.goTo('page-promotions');
}

async function saveService() {
	const method = this.id ? 'patch' : 'post';
	const url = this.id ? `promotion/${this.id}` : 'promotion';
	const message = this.id ? 'modificó' : 'creó';

	try {
		await this.$http[method](url, this.model, { headers: this.headers });
		this.showNotification(`Se ${message} la promoción correctamente.`);
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

function title() {
	const action = 'Promoción';
	return this.id ? `Editar ${action}` : `Nueva ${action}`;
}

async function loadData() {
	if (!this.id) return; // Si no hay ID, es creación, no consultamos nada.

	try {
		const response = await this.$http.get(`promotion/${this.id}`, { headers: this.headers });
		this.model = response.data.data;
		// Convertimos a booleano en caso de que la API regrese 0 o 1
		this.model.isActive = Boolean(this.model.isActive);
	} catch (error) {
		this.showError();
	}
}

function created() {
	this.loadData();
}

function validations() {
	return {
		model: {
			title: { required },
		},
	};
}

function data() {
	return {
		headers: { Accept: `${process.env.ACCEPT_SERVICE_V2}` },
		loading: false,
		model: {
			title: null,
			description: null,
			isActive: true, // Por defecto al crear, está activa
		},
	};
}

export default {
	name: 'page-new-promotion',
	data,
	components: {
		actionSidebar,
	},
	created,
	computed: {
		title,
	},
	methods: {
		closeModal,
		loadData,
		saveService,
	},
	props: {
		id: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
	},
	validations,
};
</script>


// WEBPACK FOOTER //
// src/pages/promotions/page-new-promotion.vue